import React from 'react';
import { LANG_FLAGS } from '../content';
import { pathFor, isPlainClick } from '../routes';

// Flag column on the left, same as the original site. Each flag links to the
// current page in that language, so switching language keeps you where you
// are and produces a real, shareable URL.
function LanguageSwitcher({ lang, page, onNavigate }) {
  return (
    <aside className="lang-switcher" aria-label="Language">
      {LANG_FLAGS.map(({ code, label, flag }) => (
        <a
          key={code}
          className={`lang-btn${lang === code ? ' active' : ''}`}
          href={pathFor(code, page)}
          hrefLang={code}
          lang={code}
          aria-label={label}
          aria-current={lang === code ? 'true' : undefined}
          title={label}
          onClick={(event) => {
            if (!isPlainClick(event)) return;
            event.preventDefault();
            onNavigate(code, page);
          }}
        >
          <img src={`/images/${flag}`} alt={label} />
        </a>
      ))}
    </aside>
  );
}

export default LanguageSwitcher;
